import React, { useEffect, useState } from 'react';

import FaciliterCredentialsVerificationModal from './faciliter.credentials.verification.modal.component';
import loginService from '../../domain/services/login.service';
import { resolveContactsGate } from '../../domain/services/contacts.gate.bridge';

const ContactsGateHandler = () => {
    const [gateKey, setGateKey] = useState(0);
    const [isHardBlock, setIsHardBlock] = useState(false);

    useEffect(() => {
        const handleGateBlocked = () => {
            loginService.refreshUserAuthentication((previous) => ({
                ...previous,
                faciliter: { ...(previous?.faciliter || {}), needToVerifyChannels: true },
            }));
            setIsHardBlock(true);
            setGateKey((previousKey) => previousKey + 1);
        };

        window.addEventListener('contacts:gate-blocked', handleGateBlocked);
        return () => {
            window.removeEventListener('contacts:gate-blocked', handleGateBlocked);
            resolveContactsGate(false);
        };
    }, []);

    const settleGate = (verified) => {
        setIsHardBlock(false);
        resolveContactsGate(verified);
    };

    return (
        <FaciliterCredentialsVerificationModal
            key={gateKey}
            blocking={isHardBlock}
            onClose={() => settleGate(true)}
            onDismiss={() => settleGate(false)}
        />
    );
};

export default ContactsGateHandler;
